module.exports = __webpack_public_path__ + "static/media/ace-hardware.7043d714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/ace-hardware.jpg
// module id = 1303
// module chunks = 0